// Вложения в сообщениях чатов и тикетов.
// Ограничения повторяют контракт чат-бэка: не более 10 файлов на сообщение,
// сообщение обязано содержать текст или хотя бы одно вложение.

export const CHAT_FILES_LIMIT = 10;

// Тот же потолок, что и у вложений креатива
export const CHAT_FILE_MAX_SIZE = 50 * 1024 * 1024;

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "avif"];
const VIDEO_EXTENSIONS = ["mp4", "webm", "mov", "m4v", "ogv"];
const AUDIO_EXTENSIONS = ["mp3", "wav", "ogg", "oga", "m4a", "aac", "flac"];

// Что умеем показать прямо на платформе: картинки и видео — в просмотрщике,
// аудио — плеером в пузыре; остальное только скачивается
export type ChatFileKind = "image" | "video" | "audio" | "file";

type ChatFileLike = { mime?: string | null; url?: string | null; name?: string | null };

const extensionOf = (file: ChatFileLike) =>
  (file.url || "").split("?")[0].split("#")[0].split(".").pop()?.toLowerCase() || "";

export const getChatFileKind = (file: ChatFileLike): ChatFileKind => {
  // Хранилище может отдать безликий octet-stream — тогда смотрим на расширение
  const mime = file.mime && file.mime !== "application/octet-stream" ? file.mime : "";
  if (mime) {
    if (mime.startsWith("image/")) return "image";
    if (mime.startsWith("video/")) return "video";
    if (mime.startsWith("audio/")) return "audio";
    return "file";
  }
  const extension = extensionOf(file);
  if (IMAGE_EXTENSIONS.includes(extension)) return "image";
  if (VIDEO_EXTENSIONS.includes(extension)) return "video";
  if (AUDIO_EXTENSIONS.includes(extension)) return "audio";
  return "file";
};

export const isChatImage = (file: ChatFileLike) => getChatFileKind(file) === "image";

export const chatFileName = (file: ChatFileLike) =>
  file.name || decodeURIComponent((file.url || "").split("?")[0].split("/").pop() || "") || "Файл";

export const chatFileSize = (bytes?: number | null) => {
  if (typeof bytes !== "number" || bytes <= 0) return "";
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
};
